import { Box, Container, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import photo from '../assets/HeadBack.webp';
import Blogs from '../data/Blogs.json';
import PageBanner from './SectionPageBanner';

const BlogDescription = () => {
    const { id } = useParams();
    const blog = Blogs.find((item) => item.id === parseInt(id));

    if (!blog) {
        return <Typography variant="h6" textAlign="center">Blog not found.</Typography>;
    }

    return (
        <Box>
            <PageBanner image={photo} subtitle={blog.title} />
            <Container maxWidth="md" sx={{ py: 5 }}>
                <Typography variant="h4" gutterBottom>
                    {blog.title}
                </Typography>
                <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                    {blog.content}
                </Typography>
            </Container>
        </Box>
    );
};

export default BlogDescription;
